import { render, staticRenderFns } from "./ElectronicFilingStatementFS.vue?vue&type=template&id=6104380e"
import script from "./ElectronicFilingStatementFS.vue?vue&type=script&lang=ts"
export * from "./ElectronicFilingStatementFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports